<!-- 经纪人-看板 -->
<template>
  <div id="agentBoard">
    <!-- 头部数据更新时间模块 -->
    <headerUpdate></headerUpdate>
    <div class="invite-md">
      <div class="invite-md-item" style="margin-right: 20px">
        <div class="left">
          <div class="title">
            <!-- 邀请好友 -->
            {{ $t("lanV4.Invitefriends") }}
          </div>
          <!-- 邀请码 -->
          <div class="code-md">
            <div>
              <span class="code-title">
                {{ $t("lanV4.InviteCode") }}
              </span>
              <span class="code-num">
                {{ inviteCode }}
              </span>

              <!-- 复制链接 -->
              <svg class="pos-top-2" @click="copy" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                viewBox="0 0 12 13" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.00007 0.5H12.0001V2.9H12V10.1H9.59996V2.9H4.00007V0.5ZM0 4.49997H8V12.5H0V4.49997Z"
                  fill="#909399" />
              </svg>

              <i class="el-icon-edit-outline edit-code-btn" @click="eidtCodemodalShow = true"></i>
            </div>
            <input type="text" :value="inviteCode" ref="copyInput" class="copyInput" />
          </div>
          <div class="code-url">
            <div>
              <span class="code-url-text">{{ inviteUrl }}</span>
              <!-- 复制链接 -->
              <svg class="pos-top-2" @click="copy2" xmlns="http://www.w3.org/2000/svg" width="12" height="13"
                viewBox="0 0 12 13" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.00007 0.5H12.0001V2.9H12V10.1H9.59996V2.9H4.00007V0.5ZM0 4.49997H8V12.5H0V4.49997Z"
                  fill="#909399" />
              </svg>
            </div>
            <input type="text" :value="inviteUrl" ref="copyInput2" class="copyInput" />
          </div>
        </div>
        <div class="right">
          <img class="img-l" src="../../assets/images/agent_1.png" alt="" />
        </div>
      </div>
      <div class="invite-md-item">
        <div class="left">
          <div class="title">
            <!-- 经纪人角色 -->
            {{ $t("lanV4.AgentRole") }}
          </div>
          <div class="role-md">
            <div class="role-md-l role-md-item">
              <ul>
                <li>
                  <span class="name">
                    <!-- 角色名称 -->
                    {{ $t("roleManagement.roleName") }}
                  </span>
                  <span class="val">
                    {{ roleName }}
                  </span>
                </li>
                <li>
                  <span class="name">
                    <!-- 类型 -->
                    {{ $t("common.type") }}</span><span class="val" v-if="roleTypeAgent == 0">
                    <!--比例  -->
                    {{ $t("lanV4.agentType0") }}
                  </span>
                  <span class="val" v-if="roleTypeAgent == 1 || roleTypeAgent == 2">
                    <!--极差  -->
                    {{ $t("lanV4.agentType1") }}
                  </span>
                </li>
                <li>
                  <span class="name">
                    <!-- 最高返佣等级 -->
                    {{ $t("lanV4.RebateratioLever") }}</span>
                  <span class="val">
                    {{ maxLevel }}
                  </span>
                </li>
              </ul>
            </div>
            <div class="role-md-r role-md-item">
              <ul>
                <li>
                  <span class="name">
                    <a id="tooltip-target-11" href="javascript:">
                      <!-- 返佣比例 -->
                      {{ $t("lanV4.Rebateratio") }}
                    </a>
                    <b-tooltip target="tooltip-target-11" triggers="hover">
                      <!-- 下级交易后，给经纪人的手续费分成 -->
                      {{ $t("lanV4.RebateratioTip") }}
                    </b-tooltip>
                  </span>
                  <span class="val" v-if="roleTypeAgent == 1">
                    <!-- 极差经纪人返佣比例 -->
                    {{ returnScale }}
                  </span>
                  <span class="val" v-else>
                    <!-- 比例经纪人返佣比例 -->
                    {{ returnScale }}
                  </span>
                  <!-- 返佣比例提示 -->
                  <el-popover placement="bottom" :title="$t('lanV4.Rebateratio')" width="300" manual-mode="visible"
                    trigger="click" popper-class="agent-params">
                    <div class="param-content">
                      <img @click="handlePopoverClose" class="close" src="../../assets/images/v4_close.png" alt="" />
                      <ul>
                        <li v-for="(item, index) in scaleInfo" :key="index">
                          <div class="left">
                            {{ item.key }}
                          </div>
                          <div class="right">
                            {{ item.value }}
                          </div>
                        </li>
                      </ul>
                    </div>

                    <span class="action" slot="reference" v-show="roleTypeAgent === 0 || roleTypeAgent === 2">
                      <!-- 查看(比例经纪人显示) -->
                      {{ $t("common.view") }}
                    </span>
                  </el-popover>
                </li>
                <li>
                  <span class="name">
                    <a id="tooltip-target-12" href="javascript:">
                      <!-- 返现比例 -->
                      {{ $t("lanV4.Rebateratiocash") }}
                    </a>
                    <b-tooltip target="tooltip-target-12" triggers="hover">
                      <!-- 直属下级交易后，给交易者本人的手续费分成 -->
                      {{ $t("lanV4.RebateratiocashTip") }}
                    </b-tooltip> </span><span class="val">
                    {{ returnCashScale }}
                  </span>
                  <span class="action" @click="handleChange">
                    <!-- 更改 -->
                    {{ $t("lanV4.agentChange") }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="right">
          <img class="img-r" src="../../assets/images/agent_2.png" alt="" />
        </div>
      </div>
    </div>
    <div class="invite-data-md">
      <div class="title">
        <!-- 数据总览 -->
        {{ $t("lanV4.Datascreening") }}
      </div>
      <div class="invite-card-box">
        <ul>
          <li>
            <div class="num enNum" v-if="childInfo">
              {{ childInfo.subChildNum }}
            </div>
            <div class="text">
              <!-- 直属下级数 -->
              {{ $t("lanV4.directNum") }}
            </div>
          </li>
          <li>
            <div class="num enNum" v-if="childInfo">
              {{ childInfo.allChildNum }}
            </div>
            <div class="text">
              <a id="tooltip-target-2" href="javascript:">
                <!-- 总下级数 -->
                {{ $t("lanV4.directNumAll") }}
              </a>
              <b-tooltip target="tooltip-target-2" triggers="hover">
                <!-- 可以给你返佣的下级总和 -->
                {{ $t("lanV4.directNumAllTip") }}
              </b-tooltip>
            </div>
          </li>
          <li>
            <div class="num enNum" v-if="childInfo">
              {{ childInfo.subAgentNum }}
            </div>
            <div class="text">
              <a id="tooltip-target-3" href="javascript:">
                <!-- 下级经纪人数量 -->
                {{ $t("lanV4.directNumDown") }}
              </a>
              <b-tooltip target="tooltip-target-3" triggers="hover">
                <!-- 总下级中经纪人的数量 -->
                {{ $t("lanV4.directNumDownTip") }}
              </b-tooltip>
            </div>
          </li>
          <li>
            <div class="num enNum" v-if="childInfo">
              {{ childInfo.subTradeAmount }}
            </div>
            <div class="text">
              <a id="tooltip-target-4" href="javascript:">
                <!-- 下级交易额(USDT) -->
                {{ $t("lanV4.directAmount") }}
              </a>
              <b-tooltip target="tooltip-target-4" triggers="hover">
                <!-- 总下级的合约交易额，非U币种按照统计时的汇率折算成USDT，包含开仓和平仓，不包含模拟合约 -->
                {{ $t("lanV4.directAmountTip") }}
              </b-tooltip>
            </div>
          </li>
          <li>
            <div class="num enNum" v-if="childInfo">
              {{ childInfo.returnScale }}
            </div>
            <div class="text">
              <a id="tooltip-target-5" href="javascript:">
                <!-- 我的返佣(USDT) -->
                {{ $t("lanV4.directMy") }}
              </a>
              <b-tooltip target="tooltip-target-5" triggers="hover">
                <!-- 获得的合约返佣，非U币种按照统计时的汇率折算成USD -->
                {{ $t("lanV4.directMyTip") }}
              </b-tooltip>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <b-row>
      <b-col class="chart-section">
        <b-card>
          <!--合约名称-->
          <div class="md-header">
            <div class="title">
              <!-- 我的每日返佣usdt -->
              {{ $t("lanV4.directMyChart") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('dayReturn')" :clearable="false"
                  :pickerOptions="pickerOptions">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exports">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <myDayReturnChart :loading="loading1" :loadingErr="loadingErr1" @onErrReset="getDayReturnData()"
            :returnAmountChartData="returnAmountChartData"></myDayReturnChart>
        </b-card>
      </b-col>
    </b-row>


    <el-row :gutter="20">
      <el-col :md="24" :lg="12" class="chart-section">
        <b-card>
          <div class="md-header">
            <div class="title">
              <!-- 每日新增直属下级 -->
              {{ $t("lanV4.dayNewUnderDownLevel") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray2" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('directUpNum')" :clearable="false"
                  :pickerOptions="pickerOptionsTwo">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exportsOther('', 'directUpNum')">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <dayNewUnderDownLevelChart :loading="loading2" :loadingErr="loadingErr2"
            @onErrReset="getDayData('directUpNum')" :chartData="directUpNumChartData"></dayNewUnderDownLevelChart>
        </b-card>
      </el-col>
      <el-col :md="24" :lg="12" class="chart-section">
        <b-card>
          <div class="md-header">
            <div class="title">
              <!-- 每日新增下级-->
              {{ $t("lanV4.dayNewDownLevel") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray3" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('upNum')" :clearable="false"
                  :pickerOptions="pickerOptionsTwo">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exportsOther('', 'upNum')">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <dayNewDownLevelChart :loading="loading3" :loadingErr="loadingErr3" @onErrReset="getDayData('upNum')"
            :chartData="upNumChartData"></dayNewDownLevelChart>
        </b-card>
      </el-col>
    </el-row>
    <!-- 第二列 -->
    <el-row :gutter="20">
      <el-col :md="24" :lg="12" class="chart-section">
        <b-card>
          <div class="md-header">
            <div class="title">
              <!-- 每日新增下级经纪人 -->
              {{ $t("lanV4.dayNewDownLevelAgent") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray4" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('upAgentNum')" :clearable="false"
                  :pickerOptions="pickerOptionsTwo">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exportsOther('', 'upAgentNum')">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <dayNewDownLevelAgentChart :loading="loading4" :loadingErr="loadingErr4"
            @onErrReset="getDayData('upAgentNum')" :chartData="upAgentNumChartData"></dayNewDownLevelAgentChart>
        </b-card>
      </el-col>
      <el-col :md="24" :lg="12" class="chart-section">
        <b-card>
          <div class="md-header">
            <div class="title">
              <!-- 下级每日交易额(USDT)-->
              {{ $t("lanV4.dayNewDownLevelTrade") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray5" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('upTradeAmount')" :clearable="false"
                  :pickerOptions="pickerOptionsTwo">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exportsOther('', 'upTradeAmount')">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <dayNewDownLevelTradeChart :loading="loading5" :loadingErr="loadingErr5"
            @onErrReset="getDayData('upTradeAmount')" :chartData="upTradeAmountChartData"></dayNewDownLevelTradeChart>
        </b-card>
      </el-col>
    </el-row>
    <!-- 返现比例更改弹窗 -->
    <b-modal v-model="cashBackModalShow" :title="$t('monitorModule.action2')" centered scrollable no-close-on-backdrop
      @hide="onReset">
      <div id="futuresFeeUserModal" class="body-content">
        <!-- 返现比例 -->
        <b-row class="line">
          <b-col>
            <label>{{ $t("lanV4.Rebateratiocash") }}
              <!-- <el-tooltip placement="top">
                <div slot="content" :style="{ width: tipWidth }">
                  {{ $t("lanV4.RegistrationtimeTip2") }}
                </div>
                <svg class="icon icon-14 icon-wh" aria-hidden="true">
                  <use xlink:href="#icon-v4_wh"></use>
                </svg>
              </el-tooltip> -->
            </label>
            <b-input-group>
              <b-form-input class="append-input" v-model.trim="$v.form.feeDiscount.$model" autocomplete="off"
                :state="chkState('feeDiscount')" :placeholder="$t('lanV4.RebateratiocashMaxTip', {
              feeDiscountMin: this.form.feeDiscountMin,
              feeDiscountMax: this.form.feeDiscountMax,
            })
              ">
              </b-form-input>
              <div class="append">%</div>
            </b-input-group>
            <p style="color: #93979d !important; margin: 0; margin-top: 4px">
              <!-- 不能高于当前经纪人角色的一级返佣比例 -->
              {{ $t("lanV4.RebateratiocashTip2") }}
            </p>
            <!-- 请输入返现比例 -->
            <p v-if="!$v.form.feeDiscount.required" class="text-danger">
              {{
              $t("lanV4.RebateratiocashMax", {
                feeDiscountMin: this.form.feeDiscountMin,
                feeDiscountMax: this.form.feeDiscountMax,
              })
            }}
            </p>
            <!-- 超过可输入范围 -->
            <p class="text-danger" style="margin-bottom: 0px" v-if="!$v.form.feeDiscount.proofValue">
              <!-- 请输入0.00～%s范围内的两位小数！ -->
              {{
              $t("lanV4.RebateratiocashMax", {
                feeDiscountMin: this.form.feeDiscountMin,
                feeDiscountMax: this.form.feeDiscountMax,
              })
            }}
            </p>
          </b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="primary" @click="handleSubmit">{{
              $t("lanV4.confirm")
            }}</b-button>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
              $t("common.cancel")
            }}</b-button>
      </template>
    </b-modal>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{ $t("exportsModal.text2", { pagesTotal: pages.total, maxNum: exportNumLimit }) }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
              $t("common.cancel")
            }}</b-button>
        <b-button v-if="findType" class="coustom-btn" variant="primary" @click="exportsOther('true', findType)"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
        <b-button v-else class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>
    <!-- 自定义邀请码 -->
    <editInviteCode :modalShow="eidtCodemodalShow" @changeModalShow="changeModalShow" :originalCode="inviteCode"></editInviteCode>
  </div>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import {
  multiply,
  divide,
  fixToNum,
  newFixInput,
  formatTimeDay,
  formatTime,
} from "@/apis/newmethods";
import commonMixin from "@/mixin/common/commonMixin";
import myDayReturnChart from "./components/myDayReturnChart.vue";
import dayNewUnderDownLevelChart from "./components/dayNewUnderDownLevelChart.vue";
import dayNewDownLevelChart from "./components/dayNewDownLevelChart.vue";
import dayNewDownLevelAgentChart from "./components/dayNewDownLevelAgentChart.vue";
import dayNewDownLevelTradeChart from "./components/dayNewDownLevelTradeChart.vue";
import headerUpdate from "./components/headerUpdate.vue";
import editInviteCode from "./components/editInviteCode.vue";

import { find } from "lodash";
export default {
  name: "realStatistics",
  mixins: [commonMixin],
  components: {
    myDayReturnChart,
    headerUpdate,
    editInviteCode,
    dayNewUnderDownLevelChart,
    dayNewDownLevelChart,
    dayNewDownLevelAgentChart,
    dayNewDownLevelTradeChart
  },
  data() {
    return {
      inviteCode: null, //邀请码
      inviteUrl: "", //邀请链接
      roleName: null, //角色名称
      roleTypeAgent: null, // 经纪人角色类型 （0:比例，1:极差）
      returnScale: null, //极差经纪人返佣比例
      scaleMin: null, //比例经纪人返佣比例最小值
      scaleMax: null, //比例经纪人返佣比例最大值
      returnCashScale: null, //返现 比例
      maxLevel: null, //最高返佣等级
      scaleInfo: [],
      addSave: false,
      childInfo: {}, //数据总览
      dateArray: [],
      dateArray2: [],
      dateArray3: [],
      dateArray4: [],
      dateArray5: [],
      cashBackModalShow: false,
      form: {
        feeDiscount: null, //返现比例
        feeDiscountMax: null, //返现比例最大值
        feeDiscountMin: null, //返现比例最小值
      },
      //我的每日返佣数据
      returnAmountChartData: [
        // {
        //   timestamp: "2021-04-02",
        //   amount: "100",
        // },
      ],
      returnAmount: [], //每日返佣图表数据
      directUpNumChartData: [], //每日新增直属下级
      upNumChartData: [], //每日新增下级
      upAgentNumChartData: [], //每日新增下级经纪人
      upTradeAmountChartData: [], //下级每日交易额

      isexportIng: true,
      brokerId: null, // 商户
      loading: true,
      findFlag: true, //搜索防二次点击
      beginDate: null,
      endDate: null,
      dateType: null,
      lateDateval: "", //最近时间值
      symbol: null, // 币种
      symbolList: [], // 币种列表
      showFlag: false,
      loading1: false,
      loadingErr1: false,
      loading2: false,
      loadingErr2: false,
      loading3: false,
      loadingErr3: false,
      loading4: false,
      loadingErr4: false,
      loading5: false,
      loadingErr5: false,
      findType: null,//图表类型
      eidtCodemodalShow: false,
      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },
      // 某个日期之前的时间无法选择
      pickerOptionsTwo: {
        disabledDate(time) {
          return time.getTime() < new Date('2024-05-05').getTime() || time.getTime() >  window.Date.now()-8.64e7;
        }
      },
      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
    };
  },
  computed: {
    dateList() {
      return [
        {
          label: this.$t("realStatistics.dateArr[1]"), //近1月
          value: 1,
        },
      ];
    },
    lanTxt() {
      return this.$t("realStatistics.monthList");
    },
    lan() {
      return this.$store.state.baseData.language;
    },
    isValid() {
      return !this.$v.form.$anyError;
    },
  },
  watch: {
    "form.feeDiscount"(v) {
      if (v) {
        this.$nextTick(() => {
          this.form.feeDiscount = newFixInput(v, 2, {
            num: true,
            ints: 5,
          });
        });
      }
    },
    lateDateval(val) {
      this.dateType = null;
      this.lateDateval = val;
      this.handleLateChange();
    },
  },
  created() {
    this.lateDateval = this.dateList[0];
    this.handleLateChange();
    this.showFlag = true;
    this.getDayReturnData();
    this.getData();
    this.getDayData('directUpNum') //每日新增直属下级
    this.getDayData('upNum') //每日新增下级
    this.getDayData('upAgentNum') //每日新增下级经纪人
    this.getDayData('upTradeAmount') //下级每日交易额(USDT)
  },
  validations: {
    form: {
      // 返现比例
      feeDiscount: {
        required: requiredIf(function () {
          return this.addSave;
        }),
        proofValue: function (v) {
          if (v === "-0") {
            return false;
          }
          if (v) {
            return (
              Number(v) >= this.form.feeDiscountMin &&
              Number(v) <= this.form.feeDiscountMax
            );
          }
          return true;
        },
      },
    },
  },
  methods: {
    // 选择时间
    handleChangeDate(findType) {
      if (findType !== 'dayReturn') {
        if (findType === 'directUpNum') {
          this.beginDate = this.dateArray2[0];
          this.endDate = this.dateArray2[1];
        }
        if (findType === 'upNum') {
          this.beginDate = this.dateArray3[0];
          this.endDate = this.dateArray3[1];
        }
        if (findType === 'upAgentNum') {
          this.beginDate = this.dateArray4[0];
          this.endDate = this.dateArray4[1];
        }
        if (findType === 'upTradeAmount') {
          this.beginDate = this.dateArray5[0];
          this.endDate = this.dateArray5[1];
        }
        this.getDayData(findType)
      } else {
        this.beginDate = this.dateArray[0];
        this.endDate = this.dateArray[1];
        this.getDayReturnData();
      }
    },
    copy() {
      const input = this.$refs.copyInput;
      input.select();
      document.execCommand("copy");
      // 地址复制成功
      this.$bus.$emit("alert", {
        message: this.$t("lanV4.Copy"),
        type: "success",
      });
    },
    copy2() {
      const input = this.$refs.copyInput2;
      input.select();
      document.execCommand("copy");
      // 地址复制成功
      this.$bus.$emit("alert", {
        message: this.$t("lanV4.Copy"),
        type: "success",
      });
    },
    // 更改
    handleChange() {
      this.form.feeDiscount = this.returnCashScale.replace(/%/g, ""); //反显
      this.cashBackModalShow = true;
    },
    // 查看弹窗关闭
    handlePopoverClose() {
      document.getElementById("agentBoard").click();
    },
    handleLateChange() {
      if (this.lateDateval.value === 1) {
        // this.getLastWeek();
        this.getLastMonthOne();
      }
    },
    // 获取看板数据
    getData() {
      const paramsData = {
        companyId: this.brokerId ? this.brokerId.value : undefined,
      };
      this.$http({
        url: this.$store.state.url.agent.index,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          this.brokerInfo = data.brokerInfo ? data.brokerInfo : {};
          this.inviteCode = data.inviteCode;
          let mainDomain //主域名
          if (data.inviteUrl) {
            mainDomain = new URL(data.inviteUrl).origin
            this.inviteUrl = data.inviteUrl.replace(mainDomain, window.location.origin.replace('futuresaffiliate','www'))
          } else {
            this.inviteUrl = ''
          }
          this.roleName = data.roleName;
          this.roleTypeAgent = data.roleType;
          this.returnScale = data.returnScaleInfo;
          this.returnCashScale = data.returnCashScaleInfo;
          this.scaleMin = data.scaleMin;
          this.scaleMax = data.scaleMax;
          this.maxLevel = data.maxLevel;
          this.scaleInfo = data.scaleInfo;
          this.childInfo = data.childInfo;

          // 弹窗极差经纪人返现比例最大值
          if (this.roleTypeAgent == 1) {
            this.form.feeDiscountMax = data.scaleMax.replace(/%/g, "");
            this.form.feeDiscountMin = "0.00";
          } else {
            // 弹窗比例经纪人返现比例最大值
            let scaleCashMax = data.scaleCashMax;
            // let scaleMin = data.scaleMin;
            if (scaleCashMax == null || scaleCashMax == "") {
            } else {
              scaleCashMax = data.scaleCashMax.replace(/%/g, "");
            }
            // if (scaleMin == null || scaleMin == "") {
            // } else {
            //   scaleMin = data.scaleMin.replace(/%/g, "");
            // }

            this.form.feeDiscountMax = scaleCashMax;
            // 弹窗比例经纪人返现比例最小值
            this.form.feeDiscountMin = "0.00";
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 获取每日返佣图表数据
    getDayReturnData() {
      this.loading1 = true;
      const paramsData = {
        isExport: 0, //0 查询 1导出
        startTime: this.dateArray
          ? new window.Date(this.beginDate).getTime()
          : null,
        endTime: this.dateArray
          ? new window.Date(this.endDate).getTime()
          : null,
      };
      this.$http({
        url: this.$store.state.url.agent.return_amount_day,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading1 = false;
          if (data && code.toString() === "0") {
            let arr = [];
            data.pageInfo.rows.forEach((item) => {
              arr.push({
                timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                amount: item.amount,
              });
            });
            this.returnAmountChartData = arr;
            this.pages.total = data.pageInfo.total;
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading1 = false;
          this.loadingErr1 = true;
        });
    },
    // 获取每日数据
    getDayData(findType) {
      this.handleOpenLoading(findType);
      const paramsData = {
        isExport: 0, //0 查询 1导出
        startTime: this.dateArray
          ? new window.Date(this.beginDate).getTime()
          : null,
        endTime: this.dateArray
          ? new window.Date(this.endDate).getTime()
          : null,
        type: findType
      };
      this.$http({
        url: this.$store.state.url.agent.up_info,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading2 = false;
          this.loading3 = false;
          this.loading4 = false;
          this.loading5 = false;
          if (data && code.toString() === "0") {
            let arr = [];
            // 每日新增直属下级
            if (findType === "directUpNum") {
              this.directUpNumChartData = [];
              if (data && data.pageInfo && data.pageInfo.rows) {
                data.pageInfo.rows.forEach((item) => {
                  arr.push({
                    timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                    amount: item.volume,
                  });
                });
                this.directUpNumChartData = arr;

              }
            }
            // 每日新增下级
            if (findType === "upNum") {
              this.upNumChartData = [];
              if (data && data.pageInfo && data.pageInfo.rows) {
                data.pageInfo.rows.forEach((item) => {
                  arr.push({
                    timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                    amount: item.volume,
                  });
                });
                this.upNumChartData = arr;
              }
            }
            // 每日新增下级经纪人
            if (findType === "upAgentNum") {
              this.upAgentNumChartData = [];
              if (data && data.pageInfo && data.pageInfo.rows) {
                data.pageInfo.rows.forEach((item) => {
                  arr.push({
                    timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                    amount: item.volume,
                  });
                });
                this.upAgentNumChartData = arr;
              }
            }
            // 下级每日交易额
            if (findType === "upTradeAmount") {
              this.upTradeAmountChartData = [];
              if (data && data.pageInfo && data.pageInfo.rows) {
                data.pageInfo.rows.forEach((item) => {
                  arr.push({
                    timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                    amount: item.volume,
                  });
                });
                this.upTradeAmountChartData = arr;
              }
            }
            this.pages.total = data.pageInfo.total;
          } else {
            this.handleCloseLoading();
            this.handleOpenError(findType);
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.handleCloseLoading();
          this.handleOpenError(findType);
        });
    },
    // 打开loading
    handleOpenLoading(findType) {
      if (
        findType === "directUpNum"
      ) {
        this.loading2 = true;
      }
      if (findType === "upNum") {
        this.loading3 = true;
      }
      if (findType === "upAgentNum") {
        this.loading4 = true;
      }
      if (findType === "upTradeAmount") {
        this.loading5 = true;
      }
    },
    // 关闭图表loading
    handleCloseLoading() {
      this.loading2 = false;
      this.loading3 = false;
      this.loading4 = false;
      this.loading5 = false;
    },
    // 打开错误重试
    handleOpenError(findType) {
      if (
        findType === "directUpNum"
      ) {
        this.loadingErr2 = true;
      }
      if (findType === "upNum") {
        this.loadingErr3 = true;
      }
      if (findType === "upAgentNum") {
        this.loadingErr4 = true;
      }
      if (findType === "upTradeAmount") {
        this.loadingErr5 = true;
      }
    },
    // 导出我的每日返佣(usdt)
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          isExport: 1, //0 查询 1导出
          startTime: this.dateArray
            ? new window.Date(this.beginDate).getTime()
            : null,
          endTime: this.dateArray
            ? new window.Date(this.endDate).getTime()
            : null,
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
        };
        this.outExcel(
          this.$store.state.url.agent.return_amount_day,
          paramsData,
          "increment-api"
        ).then((datas) => {
          setTimeout(() => {
            this.isexportIng = true;
          }, 500);
          if (datas.code === "0") {

            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功

          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    // 导出每日新增的其他数据
    exportsOther(istrue, findType) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
        this.findType = findType
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        if (findType === 'directUpNum') {
          this.beginDate = this.dateArray2[0];
          this.endDate = this.dateArray2[1];
        }
        if (findType === 'upNum') {
          this.beginDate = this.dateArray3[0];
          this.endDate = this.dateArray3[1];
        }
        if (findType === 'upAgentNum') {
          this.beginDate = this.dateArray4[0];
          this.endDate = this.dateArray4[1];
        }
        if (findType === 'upTradeAmount') {
          this.beginDate = this.dateArray5[0];
          this.endDate = this.dateArray5[1];
        }
        const paramsData = {
          isExport: 1, //0 查询 1导出
          startTime: this.dateArray
            ? new window.Date(this.beginDate).getTime()
            : null,
          endTime: this.dateArray
            ? new window.Date(this.endDate).getTime()
            : null,
          type: findType,
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
        };
        this.outExcel(
          this.$store.state.url.agent.up_info,
          paramsData,
          "increment-api"
        ).then((datas) => {
          setTimeout(() => {
            this.isexportIng = true;
          }, 500);
          if (datas.code === "0") {

            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功

          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    // 最近一周
    getLastWeek() {
      var end = new window.Date(new window.Date() - 1000 * 60 * 60 * 24);
      var year = end.getFullYear();
      var month = end.getMonth() + 1; //0-11表示1-12月
      var day = end.getDate();
      var dateObj = {};
      dateObj.end = year + "-" + month + "-" + day;
      if (day - 7 <= 0) {
        //如果在当月7日之前
        var startMonthDay = new window.Date(
          year,
          parseInt(month) - 1,
          0
        ).getDate(); //1周前所在月的总天数
        if (month - 1 <= 0) {
          //如果在当年的1月份
          dateObj.start = year - 1 + "-" + 12 + "-" + (31 - (7 - day + 1));
        } else {
          dateObj.start =
            year + "-" + (month - 1) + "-" + (startMonthDay - (7 - day + 1));
        }
      } else {
        dateObj.start = year + "-" + month + "-" + (day - 7 + 1);
      }
      this.beginDate = new window.Date(dateObj.start.replace(/-/g, "/"));
      this.endDate = new window.Date(dateObj.end.replace(/-/g, "/"));
      this.dateType = 1;
      this.dateArray = [this.beginDate, this.endDate];
    },
    // 最近一月
    getLastMonthOne() {
      var end = new window.Date(new window.Date() - 1000 * 60 * 60 * 24);
      var year = end.getFullYear();
      var month = end.getMonth() + 1; //0-11表示1-12月
      var day = end.getDate();
      var dateObj = {};
      dateObj.end = year + "-" + month + "-" + day;
      var endMonthDay = new window.Date(year, month, 0).getDate(); //当前月的总天数
      if (month - 1 <= 0) {
        //如果是1月，年数往前推一年<br>
        dateObj.start = year - 1 + "-" + 12 + "-" + day;
      } else {
        var startMonthDay = new window.Date(
          year,
          parseInt(month) - 1,
          0
        ).getDate();
        if (startMonthDay < day) {
          //1个月前所在月的总天数小于现在的天日期
          if (day < endMonthDay) {
            //当前天日期小于当前月总天数
            dateObj.start =
              year +
              "-" +
              (month - 1) +
              "-" +
              (startMonthDay - (endMonthDay - day));
          } else {
            dateObj.start = year + "-" + (month - 1) + "-" + startMonthDay;
          }
        } else {
          dateObj.start = year + "-" + (month - 1) + "-" + day;
        }
      }
      this.beginDate = new window.Date(dateObj.start.replace(/-/g, "/"));
      this.endDate = new window.Date(dateObj.end.replace(/-/g, "/"));
      this.dateType = 1;
      this.dateArray = [this.beginDate, this.endDate];
      this.dateArray2 = [this.beginDate, this.endDate];
      this.dateArray3 = [this.beginDate, this.endDate];
      this.dateArray4 = [this.beginDate, this.endDate];
      this.dateArray5 = [this.beginDate, this.endDate];
    },
    // 保存
    handleSubmit() {
      this.addSave = true;
      if (!this.validate()) {
        // this.$bus.$emit("alert", {
        //   type: "error",
        //   message: this.$t("lanV4.infoErr"),
        // });
        return false;
      }
      this.$http({
        url: this.$store.state.url.agent.set_cash_scale,
        params: {
          cashScale: divide(this.form.feeDiscount, 100),
        },
      }).then(({ code, msg }) => {
        if (code.toString() === "0") {
          this.getData();
          this.$bus.$emit("alert", { type: "success", message: msg });
          this.cashBackModalShow = false;
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },

    onReset() {
      this.form.feeDiscount = null;
      this.cashBackModalShow = false;
      this.addSave = false;
      this.exportsModalShow = false;
    },
    chkState(val) {
      const field = this.$v.form[val];
      if (field.$dirty) {
        if (field.$invalid) {
          return false;
        }
        return null;
      }
      return null;
    },
    validate() {
      this.$v.form.$touch();
      return this.isValid;
    },
    changeModalShow(data) {
      this.eidtCodemodalShow = data;
    },
  },
};
</script>

<style lang="scss">
.agent-params {
  .el-popover__title {
    text-align: left;
  }
}

.param-content {
  position: relative;

  .close {
    width: 12px;
    position: absolute;
    top: -30px;
    right: 0px;
    cursor: pointer;
  }

  ul {
    li {
      display: flex;
      justify-content: space-between;

      .left {
        font-size: 12px;
        color: #93979d;
      }

      .right {
        font-size: 14px;
        color: #93979d;
        font-family: "HarmonyOS-Regular" !important;
      }
    }
  }
}

#agentBoard {
  .edit-code-btn {
    font-size: 18px;
    cursor: pointer;
    margin-left: 10px;
  }
  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 230px !important;
  }

  .el-date-editor .el-range-separator {
    margin-left: 5px !important;
    margin-right: 7px !important;
    position: relative !important;
    top: -3px !important;
  }
}
</style>
<style lang="scss" scoped>
#agentBoard {
  min-width: 1310px;

  .invite-md {
    display: flex;
    justify-content: space-between;

    .invite-md-item {
      width: 50%;
      height: 143px;
      background: #fff;
      border-radius: 16px;
      display: flex;
      justify-content: space-between;

      .left {
        margin-left: 30px;

        .title {
          color: #8b909a;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          font-family: HarmonyOS-Medium;
          margin-top: 24px;
          margin-bottom: 30px;
        }

        .code-md {
          position: relative;

          .code-title {
            color: #23272e;
            font-family: HarmonyOS-Bold !important;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }

          .code-num {
            color: #23272e;
            font-family: HarmonyOS-Bold !important;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-right: 8px;
            margin-left: 1px;
          }
        }

        .code-url {
          position: relative;

          .code-url-text {
            color: #8b909a;
            font-family: HarmonyOS-Regular;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-right: 8px;
          }
        }

        .copyInput {
          position: absolute;
          opacity: 0;
        }

        .role-md {
          display: flex;
          margin-top: -10px;

          .role-md-l {
            margin-right: 5px;
          }

          .role-md-item {
            ul {
              li {
                line-height: 1;
                white-space: nowrap;

                .name {
                  color: #8b909a;
                  font-family: HarmonyOS-Regular;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                  margin-right: 8px;

                  a {
                    color: #8b909a;
                    text-decoration: none;
                    border-bottom: 1px dotted;
                  }
                }

                .val {
                  color: #24324c;
                  font-family: HarmonyOS-Bold !important;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                }

                .action {
                  color: #095be8;
                  font-family: HarmonyOS-Bold !important;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin-left: 8px;
                  cursor: pointer;
                }

                margin-bottom: 9px;
              }
            }
          }
        }
      }

      .right {
        .img-l {
          margin-top: 13px;
          margin-right: 18.53px;
        }

        .img-r {
          margin-top: 16px;
          margin-right: 17.38px;
        }
      }
    }
  }

  .invite-data-md {
    width: 100%;
    border-radius: 16px;
    background: #fff;
    height: 142px;
    margin-top: 20px;
    padding: 24px 30px 30px 30px;
    line-height: 1;
    overflow: hidden;
    margin-bottom: 20px;

    .title {
      color: #8b909a;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-family: HarmonyOS-Medium;
    }

    .invite-card-box {
      margin-top: 30px;

      ul {
        display: flex;

        li {
          margin-right: 110px;

          &:last-child {
            margin-right: 0px;
          }

          .num {
            color: #23272e;
            font-family: HarmonyOS-Bold !important;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
          }

          .text {
            color: #8b909a;
            font-family: HarmonyOS-Medium;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-top: 8px;

            a {
              color: #93979d;
              text-decoration: none;
              border-bottom: 1px dotted;
            }
          }
        }
      }
    }
  }

  .chart-section {
    position: relative;
    margin-bottom: 20px;
    border-radius: 8px !important;

    .card {
      border-radius: 16px !important;
    }

    .card-body {
      border-radius: 16px !important;
      padding: 32px 30px 24px 30px !important;
    }

    .md-header {
      display: flex;
      justify-content: space-between;

      .right {
        display: flex;
        margin-top: -8px;
      }

      .title {
        color: #24324C;
        font-family: "HarmonyOS-Medium" !important;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }

    .export {
      font-size: 14px;
      font-family: "HarmonyOS-Medium" !important;
      cursor: pointer;
      height: 32px;
      line-height: 32px;
      padding: 0 16px;
      background: #f3f4f8;
      border-radius: 4px;
      color: #24324c;
      white-space: nowrap;

      .icon-16 {
        position: relative;
        top: 1px;
      }
    }
  }
}
</style>
